//import React, { Component, useState } from 'react';
import React, { useEffect, useState } from 'react';
 import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import { API_BASE_URL } from '../..//config'; // adjust path if needed

 const Donutchart1 = () => {
// -    const [state, setstate] = useState({ 
// -
// -        series: [44, 55, 41, 17],
// -        options: {
// -            chart: { type: 'donut' },
// -            labels: ['USA', 'UK', 'Australia ', 'Europe'],
// -            fill: { colors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44'] },
// -            legend: { position: 'bottom', markers: { fillColors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44'] } },
// -            dataLabels: { enabled: false },
// -            responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: 'bottom' } } }]
// -        },
// -    })
  const [series, setSeries] = useState([0, 0, 0, 0]);
  const [labels, setLabels] = useState(['Male','Female','Other','Unknown']);

  const options = {
  chart: { type: 'donut' },
  labels,
  fill: { colors: ['#FF6B6B', '#FF6B6B', '#FF6B6B', '#FF6B6B'] }, 
  legend: { show: false },   // 🚫 removes Male/Female/Other/Unknown at the bottom
  dataLabels: { enabled: false },
     plotOptions: {
    pie: {
      donut: {
        size: "70%",

        labels: {
          show: true,

          /* 🏷️ LABEL (Department / Male / etc) */
          name: {
            show: true,
            fontSize: "14px",
            fontWeight: 600,
            color: "#333",
            offsetY: -6
          },

          /* 🔢 VALUE */
          value: {
            show: true,
            fontSize: "22px",
            fontWeight: 700,
            color: "#111",
            offsetY: 6,
            formatter: (val) => val
          },

          /* 🧮 TOTAL (shown when not hovering) */
          // total: {
          //   show: true,
          //   label: "Total",
          //   fontSize: "14px",
          //   fontWeight: 600,
          //   color: "#666",
          //   formatter: (w) =>
          //     w.globals.seriesTotals.reduce((a, b) => a + b, 0)
          // }
        }
      }
    }
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: { width: 200 }
      }
    }
  ]
};


  useEffect(() => {
    const token = localStorage.getItem('authToken');
    axios.get(`${API_BASE_URL}/deptCtc`, {
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' }
    })
    .then(res => {
      if (Array.isArray(res.data?.series)) setSeries(res.data.series);
      if (Array.isArray(res.data?.labels)) setLabels(res.data.labels);
    })
    .catch(() => {
      // keep defaults if request fails
    });
  }, []);
 
    // return (
    //    <div>
    //        <div id="chart">
    //            <ReactApexChart options={state.options} series={state.series} type="donut" />
    //         </div>
    //     </div>
    // );  
    return (
   <div id="chart">
     <ReactApexChart options={options} series={series} type="donut" />
   </div>
 );
 }
 
 export default Donutchart1;
